export default {
  brand: "AllChinaBuy Spreadsheet",
  brandShort: "Spreadsheet",
  language: "Sprog",
  nav: {
    spreadsheet: "Spreadsheet",
    categories: "Kategorier",
    reviews: "Anmeldelser",
    shipping: "Forsendelse",
    qc: "QC",
    safety: "Sikkerhed",
    guides: "Guides",
    home: "Forside",
    shoppingGuide: "Købsguide",
    mobileCategories: "Gennemse kategorier",
  },
  cta: {
    explore: "Udforsk AllChinaBuy Spreadsheet",
    visitMain: "Besøg hovedsiden",
    buyNow: "Køb nu",
    viewAll: "Se alle kategorier",
    readGuide: "Læs guide",
    readArticle: "Læs hele guiden",
    backHome: "Tilbage til forsiden",
  },
  trust:
    "Uafhængig informationsressource • Opdateres løbende • Engelsk, fransk, dansk og tysk",
  categoryNames: {
    shoes: "Sko",
    hoodies: "Hættetrøjer/Sweatere",
    tshirts: "T-shirts",
    jackets: "Jakker",
    pants: "Bukser/Shorts",
    headwear: "Hovedbeklædning",
    sets: "Sæt",
    underwear: "Undertøj",
    jersey: "Trøjer",
    accessories: "Tilbehør",
    bags: "Tasker",
    belts: "Bælter",
    perfumes: "Parfumer",
    other: "Andet",
  },
  footer: {
    disclaimer:
      "Dette er en uafhængig informationsressource uden tilknytning til eller sponsorering fra AllChinaBuy. Produktlinks fører til vores hovedside.",
    rights: "Alle rettigheder forbeholdes.",
    quickLinks: "Hurtige links",
    categories: "Kategorier",
    resources: "Ressourcer",
    about: "Om dette site",
    aboutText:
      "En flersproget ressource-hub, der hjælper dig med at organisere produktfund, sælgere og købsreferencer til AllChinaBuy.",
  },
};